// AUTO-GENERATED -- do NOT edit manually.
// Run `npm run generate-schema` to regenerate.
//
// Source of truth : pages/form/create-form.tsx (imports resolved to their source files)
// Section structure: scripts/generate-schema.mjs -> SECTION_GROUPS

export interface FormEngineChild {
  id: string
  type: string
  label: string
  isInfo: boolean
  isMandatory: boolean
  placeholder?: string
  readonly?: boolean
  disabled?: boolean
  position?: string
}

export interface FormEngineRow {
  id: string
  isDataRow: boolean
  childData: FormEngineChild[]
}

export interface FormEngineContainer {
  id: string
  rowData: FormEngineRow[]
}

export interface FormEngineButton {
  label: string
  variant: string
  position: 'top' | 'bottom'
  leftIcon?: string
  rightIcon?: string
  className?: string
}

export interface FormEngineSchema {
  containersData: FormEngineContainer[]
  selectedLayout: Record<string, number[]>
  buttons: FormEngineButton[]
}

const container: FormEngineContainer = {
  id: 'cr-container-main',
  rowData: [
    {
      id: 'cr-row-group-0-fields-1',
      isDataRow: false,
      childData: [
        { id: 'fiscalYear', type: 'Select', label: 'Fiscal Year', isInfo: true, isMandatory: true },
        { id: 'country', type: 'Select', label: 'Country', isInfo: true, isMandatory: true },
        { id: 'implementingAgency', type: 'Select', label: 'Implementing Agency', isInfo: true, isMandatory: true },
        { id: 'programType', type: 'Select', label: 'Program Type', isInfo: true, isMandatory: true },
      ],
    },
    {
      id: 'cr-row-group-0-fields-2',
      isDataRow: false,
      childData: [
        { id: 'ceilingUsd', type: 'Input', label: 'Ceiling (USD)', isInfo: false, isMandatory: true },
        { id: 'reservedUsd', type: 'Input', label: 'Reserved (USD)', isInfo: false, isMandatory: true },
        { id: 'consumedUsd', type: 'Input', label: 'Consumed (USD)', isInfo: false, isMandatory: true },
        { id: 'releasedUsd', type: 'Input', label: 'Released (USD)', isInfo: false, isMandatory: true },
      ],
    },
    {
      id: 'cr-row-group-0-fields-3',
      isDataRow: false,
      childData: [
        { id: 'remainingUsd', type: 'Input', label: 'Remaining (USD)', isInfo: false, isMandatory: false },
        { id: 'utilizationPercent', type: 'Input', label: 'Utilization %', isInfo: false, isMandatory: false },
      ],
    },
    {
      id: 'cr-row-group-0-fields-4',
      isDataRow: false,
      childData: [
        { id: 'description', type: 'Textarea', label: 'Description', isInfo: false, isMandatory: false },
      ],
    },
    {
      id: 'cr-row-group-0-fields-5',
      isDataRow: false,
      childData: [
        { id: 'attachments', type: 'uploadfile', label: 'Attachments', isInfo: false, isMandatory: false },
      ],
    },
  ],
}

const selectedLayout: Record<string, number[]> = {
  'cr-row-group-0-fields-1': [3, 3, 3, 3],
  'cr-row-group-0-fields-2': [3, 3, 3, 3],
  'cr-row-group-0-fields-3': [3, 3],
  'cr-row-group-0-fields-4': [12],
  'cr-row-group-0-fields-5': [12],
}

const buttons: FormEngineButton[] = []

export const createRequirementSchema: FormEngineSchema = {
  containersData: [container],
  selectedLayout,
  buttons,
}
